module.exports = __webpack_public_path__ + "img/xz_icon.37e1b05b.svg";